import { render, staticRenderFns } from "./gov_announce_story.vue?vue&type=template&id=1b79e9e9&lang=pug"
import script from "./gov_announce_story.vue?vue&type=script&lang=js"
export * from "./gov_announce_story.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports